import { useSelector } from 'react-redux'
import { OfferEntry as OfferEntryType } from '../../../../../types/Controlling/OfferEntry'
import OfferEntry from './OfferEntry'
import props from '../../../../../redux/props'

type Props = {
  offerEntries: OfferEntryType[]
  pull: (year?: number) => void
}

const OfferEntryList: React.FC<Props> = ({ offerEntries, pull }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  if (!offerEntries) return null
  return (
    <div>
      <div className="font-bold">{t.controlling.forecast.offerEntryList.title}</div>
      {offerEntries.length === 0 && <div className="text-gray">{t.controlling.forecast.offerEntryList.noEntries}</div>}
      {offerEntries.length > 0 && (
        <div className="flex flex-col gap-2 mt-2">
          {offerEntries.map((entry: OfferEntryType) => (
            <OfferEntry key={entry.uuid} entry={entry} pull={pull} />
          ))}
        </div>
      )}
    </div>
  )
}

export default OfferEntryList
